<template>
  <span v-bind:class="{ sidebarShow: sidebarShow == 0, hoverShowArrow: !is_mobile }" style="height: 30px">
    <div
      class="appMenu"
      v-bind:class="{ red_pointer: has_unread_notifications && isItNewMessage }"
      @click="openSidebarClicked"
      v-if="(is_mobile && !$route.query.hide_menu) || sidebarShow == 0"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.1938 3.99839H0.806156C0.360572 3.99839 0 3.55148 0 2.99919C0 2.44691 0.360572 2 0.806156 2H15.1938C15.6394 2 16 2.44691 16 2.99919C16 3.55148 15.6394 3.99839 15.1938 3.99839ZM15.1938 8.99677H0.806156C0.360572 8.99677 0 8.54986 0 7.99758C0 7.44529 0.360572 6.99838 0.806156 6.99838H15.1938C15.6394 6.99838 16 7.44529 16 7.99758C16 8.54986 15.6394 8.99677 15.1938 8.99677ZM0.806156 13.9952H15.1938C15.6394 13.9952 16 13.5482 16 12.996C16 12.4437 15.6394 11.9968 15.1938 11.9968H0.806156C0.360572 11.9968 0 12.4437 0 12.996C0 13.5482 0.360572 13.9952 0.806156 13.9952Z"
          fill="#9D9D9D"
        />
      </svg>
    </div>
    <div class="showMenu" @click="showSide" @mouseenter="showFixedSide" @mouseleave="hideFixedSide">
      <el-tooltip placement="bottom" :transition="''" v-model="hideSideTip">
        <div slot="content" style="font-size: 12px">
          <p>{{ $t('sidebar.show') }}</p>
          <p style="color: #9d9d9d; margin-top: 6px">{{ getSidebarKey }}</p>
        </div>
        <svg-icon iconClass="rArrow" className="showIcon"></svg-icon>
      </el-tooltip>
    </div>
  </span>
</template>
<script>
import { getOsType } from '../utils/utils'
import emitter from '../utils/eventbus.js'
export default {
  name: 'appMenu',
  data() {
    return {
      hideSideTip: false,
      showArrow: false,
      timer: null,
      is_mobile: this.$isMobile() || document.body.clientWidth < 640,
    }
  },
  computed: {
    isItNewMessage() {
      const notification_id = localStorage.notification_id

      const isItNewMessage =
        notification_id &&
        this.$store.state.notifications.length &&
        this.$store.state.notifications[0].id != notification_id

      return isItNewMessage
    },
    me() {
      return this.$store.state.me
    },
    has_unread_notifications() {
      for (let i in this.$store.state.notifications) {
        let notification = this.$store.state.notifications[i]
        if (!notification.readed) return true
      }
      return false
    },
    sidebarShow() {
      return this.$store.state.sidebarShow
    },
    isMac() {
      return getOsType() == 'mac'
    },
    getSidebarKey() {
      return this.$store.state.hotkeys.filter((hotkey) => hotkey.action == 'toggleSidebar')[0].key.replace('Meta', '⌘')
    },
  },
  methods: {
    openSidebarClicked() {
      if (this.is_mobile) {
        this.$emit('open-sidebar-clicked')
      } else {
        this.$store.commit('setSidebarShow', 1)
      }
    },
    showSide() {
      this.hideSideTip = false
      this.$store.commit('setSidebarShow', 1)
      clearTimeout(this.timer)
    },
    showFixedSide() {
      this.hideSideTip = true

      if (!this.showArrow) {
        return
      }
      this.timer = setTimeout(() => {
        emitter.emit('showFixedSide')
      }, 1000)
    },
    hideFixedSide() {
      clearTimeout(this.timer)
      this.timer = null
      this.hideSideTip = false
      if (!this.showArrow) {
        return
      }
      emitter.emit('hideFixedSide')
    },
    hoverShowArrow() {
      if (!document.querySelector('.main-container')) {
        return false
      }
      let mainContainerWidth = document.querySelector('.main-container').offsetWidth
      let windowWidth = window.innerWidth
      let show = (windowWidth - mainContainerWidth) / 2 > 250
      this.showArrow = show
    },
  },
  mounted() {
    // window resize
    this.hoverShowArrow()
    window.addEventListener('resize', () => {
      this.hoverShowArrow()
      this.is_mobile = this.$isMobile() || document.body.clientWidth < 640
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.hoverShowArrow()
    })
  },
}
</script>
<style scoped>
.menu {
  position: relative;
  top: 3px;
}
.red_pointer {
  position: relative;
}

.red_pointer:before {
  content: ' ';
  border: 3px solid #ff1a1a;
  border-radius: 3px;
  position: absolute;
  z-index: 100;
  right: 0%;
  margin-right: 2px;
  margin-top: 6px;
}

.showMenu,
.appMenu {
  /* position: relative;
  top: 10px; */
  display: none;
  background: var(--hoverBg);
  border-radius: 3px;
  margin: 0px;
  margin-right: 5px;
  width: 32px;
  height: 32px;
  text-align: center;
  cursor: pointer;
  margin-left: -2px;
}

.appMenu {
  display: inline-block;
  background: unset;
}
.showMenu .showIcon,
.appMenu svg {
  width: 16px;
  height: 16px;
  margin: 8px auto;
}

.showMenu .showIcon {
  width: 12px;
  height: 12px;
  padding: 10px 0;
  margin: 0 auto;
}

.hoverShowArrow:hover .appMenu {
  display: none;
}

.hoverShowArrow:hover .showMenu {
  display: inline-block;
}

.mobile:hover .showMenu {
  display: none;
}
</style>
